import { graphql } from 'react-relay';
import { usePageSpaceKey } from '@confluence/page-context';

import type {
	useSpaceHomepageIdSpaceHomepageIdQuery as useSpaceHomepageIdSpaceHomepageIdQuery$data,
	useSpaceHomepageIdSpaceHomepageIdQueryVariables as useSpaceHomepageIdSpaceHomepageIdQuery$variables,
} from './__types__/useSpaceHomepageIdSpaceHomepageIdQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

export const useSpaceHomepageId = (spaceKey?: string): string | undefined => {
	const [pageContextSpaceKey] = usePageSpaceKey();
	spaceKey = spaceKey ?? pageContextSpaceKey;
	const { data } = useQueryInterop<
		useSpaceHomepageIdSpaceHomepageIdQuery$data,
		useSpaceHomepageIdSpaceHomepageIdQuery$variables
	>(
		graphql`
			query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey: String) {
				space(key: $spaceKey) {
					homepage {
						id
					}
					id
				}
			}
		`,
		{
			variables: { spaceKey },
			skip: !spaceKey,
		},
	);
	return data?.space?.homepage?.id || undefined;
};
